import { Icon, Paper, Typography } from '@material-ui/core'
import { DocumentContext } from 'context'
import React from 'react'
import CountUp from 'react-countup'

interface Props {
  countPath?: string
  handleNotifyError: () => void
  handleLoadingFilter: (state: boolean) => void
  handleClearFilters: () => Promise<void>
}

const CountDocumentsFacturas = React.memo((props: Props) => {
  const { countPath, handleNotifyError, handleLoadingFilter, handleClearFilters } = props
  const {
    count,
    conditions,
    documentsModel,
    getDocumentsByFilters,
    setFilters,
    documentFilters: filters,
  } = React.useContext(DocumentContext)
  const { handleChangePage } = documentsModel
  const { pending, total, onhold, anuled, processes, acounted } = count
  const [recount, setRecount] = React.useState<number>(0)

  React.useEffect(() => {
    setRecount(Math.random())
  }, [])

  const handleFilter = async (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    conditionName: string
  ) => {
    e.preventDefault()
    try {
      const condiFind = conditions.find((c) => c.name === conditionName)
      if (condiFind) {
        const newFilters = { ...filters, conditions: [condiFind] }
        setFilters(newFilters)
        handleLoadingFilter(true)
        await getDocumentsByFilters(undefined, undefined, newFilters)
      } else {
        setFilters({ ...filters, conditions: [] })
      }
      handleChangePage(undefined, 0)
      handleLoadingFilter(false)
    } catch (error) {
      handleNotifyError()
    } finally {
      handleLoadingFilter(false)
    }
  }
  return (
    <div className="flex items-center w-full pb-4 justify-between">
      <Paper
        className="px-4 py-3 flex flex-grow mr-2 items-center justify-start relative overflow-hidden cursor-pointer"
        style={{
          backgroundColor: '#a4a4a4',
          flex: 1,
          maxWidth: '50%',
        }}
        elevation={0}
        onClick={async (e) => {
          await handleFilter(e, 'Contabilizado')
        }}
      >
        <div className="glass-md flex items-center justify-center p-2">
          <Icon className="opacity-50">flag</Icon>
        </div>
        <div className="ml-4">
          <CountUp start={recount} duration={1} end={acounted}>
            {({ countUpRef }) => (
              <div>
                <Typography variant="h5" style={{ fontWeight: 900, color: '#393636' }}>
                  <span ref={countUpRef} />
                </Typography>
              </div>
            )}
          </CountUp>
          <Typography variant="caption" className="opacity-75 font-bold">
            {'Contabilizadas'}
          </Typography>
        </div>
      </Paper>

      {/* <Paper
        className="px-4 py-3 flex flex-grow mr-2 items-center justify-start relative overflow-hidden cursor-pointer"
        style={{
          backgroundColor: "#FABF2E",
          flex: 1,
        }}
        elevation={0}
        onClick={async (e) => {
          await handleFilter(e, "En Espera")
        }}
      >
        <div className="glass-md flex items-center justify-center p-2">
          <Icon className="opacity-50">close</Icon>
        </div>
        <div className="ml-4">
          <CountUp start={recount} duration={1} end={onhold}>
            {({ countUpRef }) => (
              <div>
                <Typography
                
                  variant="h5"
                  style={{ fontWeight: 900, color: '#393636' }}
                >
                  <span ref={countUpRef} />
                </Typography>
              </div>
            )}
          </CountUp>
          <Typography variant="caption" className="opacity-75 font-bold">
            {"En Espera"}
          </Typography>
        </div>
      </Paper> */}

      <Paper
        className="px-4 py-3 flex flex-grow mr-2 items-center justify-start relative overflow-hidden cursor-pointer"
        style={{
          backgroundColor: '#8b8b8b',
          flex: 1,
        }}
        elevation={0}
        onClick={async (e) => {
          await handleFilter(e, 'Pendiente')
        }}
      >
        <div className="glass-md flex items-center justify-center p-2">
          <Icon className="opacity-50">arrow_upward</Icon>
        </div>
        <div className="ml-4">
          <CountUp start={recount} duration={1} end={pending}>
            {({ countUpRef }) => (
              <div>
                <Typography variant="h5" style={{ fontWeight: 900, color: '#393636' }}>
                  <span ref={countUpRef} />
                </Typography>
              </div>
            )}
          </CountUp>
          <Typography variant="caption" className="opacity-75 font-bold">
            {'Pendientes'}
          </Typography>
        </div>
      </Paper>

      <Paper
        className="px-4 py-3 flex flex-grow mr-2 items-center justify-start relative overflow-hidden cursor-pointer"
        style={{
          backgroundColor: '#757474',
          flex: 1,
          maxWidth: '50%',
        }}
        elevation={0}
        onClick={async (e) => {
          await handleFilter(e, 'En Proceso')
        }}
      >
        <div className="glass-md flex items-center justify-center p-2">
          <Icon className="opacity-50">flag</Icon>
        </div>
        <div className="ml-4">
          <CountUp start={recount} duration={1} end={processes}>
            {({ countUpRef }) => (
              <div>
                <Typography variant="h5" style={{ fontWeight: 900, color: '#393636' }}>
                  <span ref={countUpRef} />
                </Typography>
              </div>
            )}
          </CountUp>
          <Typography variant="caption" className="opacity-75 font-bold">
            {'Por Contabilizar'}
          </Typography>
        </div>
      </Paper>

      <Paper
        className="px-4 py-3 flex flex-grow mr-2 items-center justify-start relative overflow-hidden cursor-pointer"
        style={{
          backgroundColor: '#656565',
          flex: 1,
        }}
        elevation={0}
        onClick={async (e) => {
          await handleFilter(e, 'Anulado_NC')
        }}
      >
        <div className="glass-md flex items-center justify-center p-2">
          <Icon className="opacity-50">timelapse</Icon>
        </div>
        <div className="ml-4">
          <CountUp start={recount} duration={1} end={anuled}>
            {({ countUpRef }) => (
              <div>
                <Typography variant="h5" style={{ fontWeight: 900, color: '#393636' }}>
                  <span ref={countUpRef} />
                </Typography>
              </div>
            )}
          </CountUp>
          <Typography variant="caption" className="opacity-75 font-bold">
            {'Anuladas'}
          </Typography>
        </div>
      </Paper>

      <Paper
        className="px-4 py-3 flex items-center justify-start relative overflow-hidden"
        style={{
          backgroundColor: '#ff8f00',
        }}
        elevation={0}
        onClick={async () => {
          await handleClearFilters()
        }}
      >
        <div className="mx-4">
          <CountUp start={recount} duration={1} end={total}>
            {({ countUpRef }) => (
              <div>
                <Typography
                  variant="h5"
                  style={{ fontWeight: 900, color: '#393636' }}
                  align="center"
                >
                  <span ref={countUpRef} />
                </Typography>
              </div>
            )}
          </CountUp>
          <Typography variant="caption" className="opacity-75 font-bold">
            {'Total'}
          </Typography>
        </div>
      </Paper>
    </div>
  )
})

export default CountDocumentsFacturas
